export default {
  presenter: 'polasek',
  title: 'Jak na plošné spoje, jde to i open-source cestou?',
  subtitle: 'mírně pokročilí',
  text: `
Jdou dělat plošňáky i na Linuxu / Unixu a pomocí open-source softwaru? Vyrovná se komerčnímu
softwaru? Co funkce a použitelnost? A co na to Jan Tleskač?
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/polasek-plosne-spoje.js